/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The NftGeneratorControllerDtoNftImageRecoveryRequest model module.
 * @module model/NftGeneratorControllerDtoNftImageRecoveryRequest
 * @version 1.0
 */
class NftGeneratorControllerDtoNftImageRecoveryRequest {
    /**
     * Constructs a new <code>NftGeneratorControllerDtoNftImageRecoveryRequest</code>.
     * @alias module:model/NftGeneratorControllerDtoNftImageRecoveryRequest
     */
    constructor() { 
        
        NftGeneratorControllerDtoNftImageRecoveryRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>NftGeneratorControllerDtoNftImageRecoveryRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/NftGeneratorControllerDtoNftImageRecoveryRequest} obj Optional instance to populate.
     * @return {module:model/NftGeneratorControllerDtoNftImageRecoveryRequest} The populated <code>NftGeneratorControllerDtoNftImageRecoveryRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new NftGeneratorControllerDtoNftImageRecoveryRequest();

            if (data.hasOwnProperty('forceUpdate')) {
                obj['forceUpdate'] = ApiClient.convertToType(data['forceUpdate'], 'Boolean');
            }
            if (data.hasOwnProperty('startNftUid')) {
                obj['startNftUid'] = ApiClient.convertToType(data['startNftUid'], 'Number');
            }
            if (data.hasOwnProperty('endNftUid')) {
                obj['endNftUid'] = ApiClient.convertToType(data['endNftUid'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>NftGeneratorControllerDtoNftImageRecoveryRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>NftGeneratorControllerDtoNftImageRecoveryRequest</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Boolean} forceUpdate
 */
NftGeneratorControllerDtoNftImageRecoveryRequest.prototype['forceUpdate'] = undefined;

/**
 * @member {Number} startNftUid
 */
NftGeneratorControllerDtoNftImageRecoveryRequest.prototype['startNftUid'] = undefined;

/**
 * @member {Number} endNftUid
 */
NftGeneratorControllerDtoNftImageRecoveryRequest.prototype['endNftUid'] = undefined;






export default NftGeneratorControllerDtoNftImageRecoveryRequest;

